import { universalSignatureValidatorAbi } from '../../constants/abis.js';
import { universalSignatureValidatorByteCode } from '../../constants/contracts.js';
import { CallExecutionError } from '../../errors/contract.js';
import { isBytesEqual } from '../../utils/data/isBytesEqual.js';
import { encodeDeployData, isHex, toHex } from '../../utils/index.js';
import { call } from './call.js';
export async function verifyHash(client, { address, hash, signature, ...callRequest }) {
    const signatureHex = isHex(signature) ? signature : toHex(signature);
    try {
        const { data } = await call(client, {
            data: encodeDeployData({
                abi: universalSignatureValidatorAbi,
                args: [address, hash, signatureHex],
                bytecode: universalSignatureValidatorByteCode,
            }),
            ...callRequest,
        });
        return isBytesEqual(data ?? '0x0', '0x1');
    }
    catch (error) {
        if (error instanceof CallExecutionError) {
            return false;
        }
        throw error;
    }
}
//# sourceMappingURL=verifyHash.js.map